import { useTranslation } from "react-i18next";
import { updateSlide } from "../../../store/common/common-slice";
import { useRootDispatch, useRootSelector } from "../../../store/hooks";
import { CardStack } from "../../common/cardStack/CardStack";
import classes from "./SavedPaymentMethods.module.scss";
import { selectAllPaymentMethods } from "store/paymentMethods/paymentMethods-slice";
import { Loader } from "rsuite";
import { useMemo } from "react";

import {
  getAccountRestrictions,
  selectedAccountInfo,
} from "store/account/account-selector";
import { isExpired } from "utility/utils";

export const SavedPaymentMethods = () => {
  const allPaymentMethods = useRootSelector(selectAllPaymentMethods);
  const paymentMethods = allPaymentMethods.filter(
    (method) => !isExpired(method.expirationDate),
  );
  const { meta } = useRootSelector((state) => state.paymentMethods);
  const { t } = useTranslation(["common"]);
  const accountInfo = useRootSelector(selectedAccountInfo);

  const { restrictions } = useRootSelector(getAccountRestrictions);

  const dispatch = useRootDispatch();

  const actionDisabled: boolean = useMemo(() => {
    return (
      accountInfo?.active !== true ||
      (restrictions.achRestricted && restrictions.cardRestricted)
    );
  }, [accountInfo, restrictions]);

  return (
    <div className={classes.SavedPaymentWrapper}>
      {paymentMethods && paymentMethods.length ? (
        <>
          <CardStack data={paymentMethods.slice(0, 3)}></CardStack>
          {paymentMethods.length > 3 ? (
            <p
              data-testid="saved-payment-methods-view-more"
              className={classes.ViewDetail}
              onClick={() => {
                dispatch(updateSlide({ id: "ManageWallet" }));
              }}
            >
              <span>{t("common:view_more")}</span>
            </p>
          ) : null}
        </>
      ) : meta.isLoading ? (
        <Loader />
      ) : (
        <p className={[classes.EmptyMessage, "rsuite-custom"].join(" ")}>
          {t("common:no_data_found_saved_payment_method")}
        </p>
      )}
      <div
        className={[
          classes.ButtonWrapper,
          paymentMethods.length <= 3 ? classes.ButtonMargin : "",
        ].join(" ")}
      >
        <ft-button
          class={[classes.Autopay, "outline-button"].join(" ")}
          label={t("common:manage_autopay")}
          disabled={actionDisabled ? actionDisabled : null}
          onClick={() => {
            dispatch(updateSlide({ id: "ManageWallet", tab: 1 }));
          }}
          outlined
        ></ft-button>
        <ft-button
          data-testid="saved-payment-methods-add-button"
          label={t("common:add_payment_method", {
            value: "+",
          })}
          disabled={actionDisabled ? actionDisabled : null}
          onClick={() => {
            dispatch(updateSlide({ id: "AddPaymentMethods" }));
          }}
          unelevated
        ></ft-button>
      </div>
    </div>
  );
};
